export const actions = {
  backup: 'BACKUP',
  delete: 'DELETE',
};
